var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-poll" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("surveys")) + "\n        ")
        ],
        1
      ),
      _c("q-table", {
        attrs: {
          data: _vm.surveys,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "fas fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "admin_survey",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n                "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.id) +
                          "\n                "
                      )
                    ]
                  ),
                  _c("q-td", { key: "title", attrs: { props: props } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(props.row.title) +
                        "\n                "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "permission", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label: _vm.getQuantity(props.row.permission),
                            "no-ripple": ""
                          }
                        },
                        [
                          _c("q-tooltip", [
                            props.row.permission.areas.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("areas")) +
                                        ":\n                                "
                                    ),
                                    _vm._l(props.row.permission.areas, function(
                                      area,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.getArea(area)) +
                                            "\n                                    "
                                        ),
                                        props.row.permission.areas.length - 1 >
                                        index
                                          ? _c("span", [_vm._v(", ")])
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            props.row.permission.clients.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("clients")) +
                                        ":\n                                "
                                    ),
                                    _vm._l(
                                      props.row.permission.clients,
                                      function(client, index) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.getClient(client)) +
                                              "\n                                    "
                                          ),
                                          props.row.permission.clients.length -
                                            1 >
                                          index
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ])
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            props.row.permission.user_groups.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("user_groups")) +
                                        ":\n                                "
                                    ),
                                    _vm._l(
                                      props.row.permission.user_groups,
                                      function(user_group, index) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getUserGroup(user_group)
                                              ) +
                                              "\n                                    "
                                          ),
                                          props.row.permission.user_groups
                                            .length -
                                            1 >
                                          index
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ])
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            props.row.permission.profiles.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("profiles")) +
                                        ":\n                                "
                                    ),
                                    _vm._l(
                                      props.row.permission.profiles,
                                      function(profile, index) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.getUserProfile(profile)
                                              ) +
                                              "\n                                    "
                                          ),
                                          props.row.permission.profiles.length -
                                            1 >
                                          index
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ])
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("q-td", { key: "survey_type", attrs: { props: props } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(_vm.getSurveyType(props.row.survey_type))
                        ) +
                        "\n                "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "qty_survey_questions", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.qty_survey_questions) +
                          "\n                "
                      )
                    ]
                  ),
                  _c("q-td", { key: "start_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.fDate(props.row.start_date)) +
                        "\n                "
                    )
                  ]),
                  _c("q-td", { key: "end_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.fDate(props.row.end_date)) +
                        "\n                "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "fas fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "admin_survey",
                                params: { id: props.row.actions }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "secondary",
                            icon: "fas fa-chart-line"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showReport(props.row)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("view_report_for_this_survey_tooltip")
                                ) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c("report", {
        attrs: {
          show_report_survey: _vm.show_report_survey,
          id: _vm.id,
          title: _vm.title,
          status: _vm.status,
          is_anonymous: _vm.is_anonymous
        },
        on: { hide_report: _vm.hideReport }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }